<template>
    <div class="formulario animate__animated animate__backInLeft">
     <h1>{{defina}}</h1>
        <div class="Formulario-title">{{title}}</div>
        <small class="error" v-show="deuErro">Não é permitido espaços ou campo vazio</small>
        <input type="text" class="formulario-input" v-model="inputValue" v-on:keyup.enter="onSubmit" :placeholder="defina">
        <button @click="song" class="final-botao" v-on:click="onSubmit" :disabled='inputValue.length === 0'>{{button}}</button>
    </div>
</template>

<script>
export default{
    name:'Formulario',
    props:{
        title: String,
        button: String,
        action: Function,
        defina: String,
    },
    data(){
        return{
            deuErro: false,
            inputValue: ''
        }
    },
    methods:{
        onSubmit: function(){
            if(this.inputValue === "" || this.inputValue.indexOf(' ') >= 0 || this.inputValue.indexOf('?') >= 0 || this.inputValue.indexOf('-') >= 0 || this.inputValue.indexOf('_') >= 0 || this.inputValue.indexOf('@') >= 0 || this.inputValue.indexOf('+') >= 0 || this.inputValue.indexOf('{') >= 0 || this.inputValue.indexOf('}') >= 0 || this.inputValue.indexOf('.') >= 0 ){
               this.deuErro = true;
               return false;
            }
       
            this.deuErro = false;
            this.action(this.inputValue);
            this.inputValue = ""
        },

        
        song(){
        var click = new Audio('/songs/click.mp3');
        click.play();
        }
    }
}
</script>

<style scoped>
    .Formulario-title{
        padding-bottom:9px;
        max-width: 500px;
        font-weight: lighter;
        font-size: 14px;
        width:90%;
        text-align: center;
    }
    h1{ 
        font-size: 40px;
        font-weight: bold;
        position: relative;
        top: -60px;
        text-shadow: 3px 2px 1px rgba(71, 212, 71, 0.4);
        color: rgb(112, 253, 46);
    }
    .formulario{
        font-size: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        flex-direction: column;
        
    }
    .formulario-input{
        
        padding: 10px 5px;
        border-radius: 5px;
        margin:10px 0px;
        font-size: 20px;
        color:var(--color-background);
    }
    input{
        outline: none;
        border:none;
        border:4px solid rgba(183, 189, 181);
    }
    input:active,input:hover,input:focus{
        border:4px solid rgba(81, 233, 10, 0.486);
        outline: none;
    }
    
    .final-botao{
        margin-top: 20px;
        padding: 9px 24px;
        background: var(--color-background-button);
        color: silver;
        color:#fff;
        outline: none;
        border:0;
        font-size: 15px;
        border-radius: 4px; 
        font-weight: bold;
        border:2px solid;  
        cursor: pointer;
        box-shadow: 1px 2px 1px 3px rgba(18, 43, 184, 0.1);
        transition: ease-in-out 0.3s;
        position: relative;
    }
    .final-botao::before{
        content: '';
        position: absolute;
        top: 10%;
        filter: blur(0.4px);
        left: 90%;
        border-radius: 50%;
        background: #fff;
        width: 5px;
        height: 5px;
        box-shadow: 1px 1px 2px 2px rgba(255, 255, 255, 0.931);
    }
    .final-botao:hover{
        background: rgba(77, 219, 11, 0.472);
    }
    button[disabled]{
        pointer-events: none;
        opacity: 0.5;
    }
    button::before[disabled]{
        display: none;
    }
    .error{
        color:rgb(248, 58, 44);
        padding:5px 0;
    }
</style>
